(function(){
  var rv=parseFloat(window.__crpv)||0;
  var rc=parseInt(window.__crpc)||0;
  if(rv<=0)return;
  var title=document.querySelector('.product__title');
  if(!title)return;
  var fl=Math.floor(rv),dec=rv-fl,h='';
  for(var i=1;i<=5;i++){
    if(i<=fl){
      h+='<span style="color:#FFA800;font-size:18px;line-height:1;">&#9733;</span>';
    } else if(i===fl+1&&dec>=0.3){
      var pct=Math.round(dec*100);
      h+='<span style="position:relative;display:inline-block;font-size:18px;line-height:1;"><span style="color:#e0e0e0;">&#9733;</span><span style="position:absolute;left:0;top:0;overflow:hidden;width:'+pct+'%;color:#FFA800;">&#9733;</span></span>';
    } else {
      h+='<span style="color:#e0e0e0;font-size:18px;line-height:1;">&#9733;</span>';
    }
  }
  var label=rc>0?'<span style="font-size:14px;color:#888;margin-left:6px;font-family:var(--font-body-family);">'+rv.toFixed(1).replace('.',',')+' Sterne von '+rc+' Bewertungen</span>':'';
  var div=document.createElement('div');
  div.style.cssText='display:flex;align-items:center;gap:3px;margin:-2px 0 10px;flex-wrap:wrap;cursor:pointer;';
  div.title='Kundenbewertungen anzeigen';
  div.innerHTML=h+label;
  // Scroll to review section on click
  div.addEventListener('click',function(){
    var target=document.getElementById('cr-reviews')||
               document.querySelector('.cr-rv-wrap')||
               document.querySelector('[id*="cr_reviews"]');
    if(target)target.scrollIntoView({behavior:'smooth',block:'start'});
  });
  title.insertAdjacentElement('afterend',div);
})();